import { useEffect, useState } from 'preact/hooks';

// A hand-rolled, dependency-free router rather than pulling in
// preact-router: hash-based paths (`#/auditions/callback`) work on ANY
// static host with zero server-side rewrite config — which mattered
// because A2.1a shipped no server wiring at all; real path-based routing
// can follow once something owns an SPA-fallback rewrite rule.
//
// This stays a raw string in/string out router on purpose — routes/
// route.ts's parseRoute/routePath own all the STRUCTURE (the 5 tabs, each
// one's Strip sub-view, the Materials workshop) on top of the plain path
// string this hook hands back; this file only ever talks to
// `window.location.hash`.
function normalize(hash: string): string {
  const path = hash.replace(/^#/, '');
  return path || '/';
}

export function useHashRoute(): [string, (path: string) => void] {
  const [route, setRoute] = useState(() => normalize(window.location.hash));

  useEffect(() => {
    const onChange = () => setRoute(normalize(window.location.hash));
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  const navigate = (path: string) => {
    window.location.hash = path;
  };

  return [route, navigate];
}
